import { setQueryParams } from "@/utils/url";
import axios from "axios";
import { apiCall } from "./ApiResult.model";

export const getAuditLogConcentUrl = apiCall<void, string>(
  "auditlog-url",
  async () => {
    const res = await axios.get("/additional-consent/auditlog/url");
    let url = res.data;

    url = setQueryParams(url, [
      ["state", "auditlog"],
      ["redirect_uri", location.origin + "/mapping"],
    ]);

    return {
      success: true,
      value: url,
    };
  }
);

export const sendAuditLogConsentCode = apiCall<string, string>(
  "auditlog-code",
  async (code) => {
    const redirectUri = location.origin + "/mapping";
    const provider = "auditlog";
    const res = await axios.post("/additional-consent", {
      code,
      redirectUri,
      provider,
    });
    return {
      success: true,
      value: res.data,
    };
  }
);

export const getMipConcentUrl = apiCall<void, string>("mip-url", async () => {
  const res = await axios.get("/additional-consent/mip/url");
  const url = setQueryParams(res.data as string, [
    ["state", "mip"],
    ["redirect_uri", location.origin],
  ]);
  return {
    success: true,
    value: url,
  };
});

export const sendMipConsentCode = apiCall<string, string>(
  "mip-code",
  async (code) => {
    const redirectUri = location.origin;
    const provider = "mip";
    const res = await axios.post("/additional-consent/service", {
      code,
      redirectUri,
      provider,
    });
    return {
      success: true,
      value: res.data,
    };
  }
);

export const notifyMipSuccess = apiCall<void, number>(
  "mip-success",
  async () => {
    await axios.post("/extproxy/integrations/mip/consent");
    await axios.put("/extproxy/integrations/ui-settings", {
      uiSettings: {
        mip: {
          added: true,
          on: true,
        },
        flag_mip_step_done: true,
      },
    });
    return {
      success: true,
      value: 200,
    };
  }
);

export const activate_onedrive_scanner = apiCall<void, boolean>(
  "activate-onedrive-scanner",
  async () => {
    await axios.post("/extproxy/integrations/onedrive");
    return {
      success: true,
      value: true,
    };
  }
);
